// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3pdnd","head":"Table_head__1UCho","col":"Table_col__QB5wq"};